<template>
  <div class="page-content">
    <page-template
      ref="birthday"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      @searchReset="searchReset"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>
<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';


  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {
      pageTemplate
    },
    data() {
      let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD')
      let edCreateDttm = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
      return {
        value: new Date(),
        toolConfig: [
          {
            label: "导出",
            code: "export",
            callback: this.exportData
          },
        ],
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: "", prop: "otherName", type: "input", span: 12, isFuzzy: true, placeholder: "请输入会员姓名/卡号/手机号"},
          ],
          complex: [
            // {
            //   label: "",
            //   prop: "dateType",
            //   type: "radioOne",
            //   data:[{name:'查看近期生日天数范围',value:'1'},{name:'选择日期范围',value:'2'}],
            //   span: 8,
            //   defaultValue:'1',
            //   change:this.changeDate,
            // },
            // {
            //   label: '查看生日范围',
            //   type: 'select',
            //   prop: 'dateType',
            //   span: 6,
            //   defaultValue:'1',
            //   data: [{name:'近期过生日会员天数',id:'1'},{name:'选择日期范围',id:'2'},],
            //   change:this.changeDate,
            // },
            // {label: "", prop: "number", type: "input", span: 6,hidden:false,placeholder:'请输入天数',inputType:'number',defaultValue:30,},

            {
              label: "查看生日范围",
              prop: "CreateDttm",
              type: "datetimeRange",
              dateType: "datetime",
              format: "MM-dd",
              span: 8,
            },
            {
              label: '发卡门店',
              type: 'select',
              prop: 'storeId',
              span: 8,
              data: [],
              isHasAll: true,
              url: api.store.store,
            },
            {
              label: '会员类别',
              type: 'select',
              prop: 'memberCategoryId',
              span: 8,
              data: [],
              url: api.member.category,
            },
          ]
        },
        // 表格信息配置
        tableOptions: {
          tableName: 'birthdayTable',
          indexShow: true,//是否显示索引,
          param: {
            stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            edCreateDttm: this.$moment().add(30, 'days').format('YYYY-MM-DD HH:mm:ss')
          },
          columns: [
            {label: '卡号', prop: 'cardNum', width: '120', align: 'center'},
            {label: '姓名', prop: 'name', width: '120', align: 'center'},
            {label: '手机号', prop: 'phone', width: '120', align: 'center'},
            {label: '生日', prop: 'memberBirthday', width: '120', align: 'center'},
            {label: '发卡门店', prop: 'storeName', width: '150', align: 'center'},
            {label: '会员类别', prop: 'memberCategoryName', width: '100', align: 'center'},
            {
              label: '性别',
              prop: 'sex',
              width: '80',
              align: 'center',
              enumData: this.$utils.getCacheStatus("mbMember.sex")
            },
            {label: '地址', prop: 'address', width: '150', align: 'center'},
            {label: '剩余积分', prop: 'usableIntegral', width: '120', align: 'center'},
            {label: '储值余额', prop: 'balance', width: '120', align: 'center'},
          ],
          // url: api.member.birthday
        },
      }
    },
    created() {
      // this.stCreateDttm = this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
      // this.edCreateDttm = this.$moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
      this.stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD')
      this.edCreateDttm = this.$moment().add(30, 'days').format('YYYY-MM-DD')//往后30天
      this.setStore(this.searchOptions.complex)
    },
    mounted() {
      this.setDefaultDate()
      if (Object.keys(this.$route.params).length > 0) {
        this.tableOptions.param = {
          stCreateDttm: this.stCreateDttm + ' 00:00:00',
          edCreateDttm: this.edCreateDttm + ' 23:59:59'
        }
      }
      this.$nextTick(() => {
        this.tableOptions.url = api.member.birthday
        this.$refs['birthday'].operationSuccess();
      })
    },
    methods: {
      setDefaultDate() {
        this.$refs['birthday'].$refs['searchFormTemp'].$refs['CreateDttm'][0].setValue(this.stCreateDttm + ' 00:00:00', this.edCreateDttm + ' 23:59:59')
      },
      // changeDate(form,column){
      //   console.log(column)
      //   if(form.dateType === '2'){
      //     this.searchOptions.complex.filter(v=>v.prop === 'CreateDttm')[0].hidden = false
      //     this.searchOptions.complex.filter(v=>v.prop === 'number')[0].hidden = true
      //   }else{
      //     this.searchOptions.complex.filter(v=>v.prop === 'CreateDttm')[0].hidden = true
      //     this.searchOptions.complex.filter(v=>v.prop === 'number')[0].hidden = false
      //   }
      // },
      // // 重置
      searchReset() {
        // this.setDefaultDate()
        // this.tableOptions.param={
        //   stCreateDttm : this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        //   edCreateDttm:this.$moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
        // }
        // this.$refs.birthday.operationSuccess()
      },

      exportData() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = {
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          edCreateDttm: this.$moment().add(30, 'days').format('YYYY-MM-DD HH:mm:ss')
        }
        Object.assign(param, this.$refs["birthday"].getCurrentParams());
        this.$axios.PostBlob(api.member.birthdayExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '会员生日_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      }
    },
  }
</script>

<style scoped>
  .page-template {
    padding-top: 0;
  }
</style>




// WEBPACK FOOTER //
// src/page/member/Birthday.vue